/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBadge = createReactComponent("outline", "badge", "IconBadge", [["path", { "d": "M17 17v-13l-5 3l-5 -3v13l5 3z", "key": "svg-0" }]]);

export { IconBadge as default };
//# sourceMappingURL=IconBadge.mjs.map
